<template>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label class="label">по рассылке {{campaign.name}}</label>
          <label class="label">Номер телефона {{callTask.phone}}</label>
          <div class="control">
            <p class="control">
              Состояние  <input v-model="callTaskState" type="text" readonly>
            </p>
            <collapse accordion>
              <collapse-item title="Результаты" selected>
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th>Параметр</th>
                    <th>Значение</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="res in results">
                    <td>
                      {{res[0]}}
                    </td>
                    <td v-if="res[0]=='time'">
                      {{getDateTime(res[1])}}
                    </td>
                    <td v-if="res[0]!='time'">
                      {{res[1]}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </collapse-item>
              <collapse-item title="Информация">
                <p class="info">
                  Тег  <input v-model="callTask.tag" type="text" readonly>
                </p>
                <p class="info">
                  failComment  <input v-model="callTask.failComment" type="text" readonly>
                </p>
                <p class="info">
                  calledTimestamp  <input v-model="callTask.calledTimestamp" type="text" readonly>
                </p>
                <p class="info">
                  talkMillis  <input v-model="callTask.talkMillis" type="text" readonly>
                </p>
                <p class="info">
                  nextAttemptTimestamp  <input v-model="callTask.nextAttemptTimestamp" type="text" readonly>
                </p>
                <p class="info">
                  parameters  <input v-model="callTaskParameters" type="text" readonly>
                </p>
                <p class="info">
                  reportParameters  <input v-model="callTaskReportParameters" type="text" readonly>
                </p>
                <p class="info">
                  created  <input v-model="callTask.created" type="text" readonly>
                </p>
              </collapse-item>
            </collapse>
          </div>

            <p class="control">
              <button class="button is-light" v-on:click="cancel">
                <span class="icon">
                  <i class="fa fa-times-circle"></i>
                </span>
                <span>Закрыть</span>
              </button>
            </p>
        </article>
      </div>
    </div>

</template>

<script>
import Cleave from 'vue-cleave'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
import CheckToken from '../authentication/CheckToken'
import CheckPermission from '../authentication/CheckPermission'
import GetCalltaskState from './GetCalltaskState'

Vue.mixin(CheckToken)
Vue.mixin(CheckPermission)
Vue.mixin(GetCalltaskState)

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

const CALLTASKTESTING_API = '/outgoing-cpg/callTasksTesting'
const CAMPAIGNS_API = '/api/campaigns'

export default {
  props: ['campaignid', 'id'],
  data () {
    return {
      callTask: {},
      callTaskState: '',
      callTaskParameters: '',
      callTaskReportParameters: '',
      campaign: '',
      title: '',
      results: {},
      permissionKey: 'campaign'
    }
  },
  components: {
    Cleave,
    Notification,
    Collapse,
    CollapseItem
  },
  created: function () {
    this.checkToken()
    this.handlePhone()
  },
  computed: {
    ...mapGetters([
      'loggedUser',
      'authenticationToken'
    ])
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    handlePhone() {
      this.loadCampaign()
      this.loadCallTask()
    },
    loadCallTask () {
      this.$http({
        url: CALLTASKTESTING_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('opening testing call task ' + response.data.phone)
        this.callTask = response.data
        this.callTaskState = this.getCallTaskState(this.callTask.state)
        this.callTaskParameters = JSON.stringify(this.callTask.parameters)
        this.callTaskReportParameters = JSON.stringify(this.callTask.reportParameters)
        this.results = Object.entries(this.callTask.scenarioResult.items[0])
        for (var i = 1; i < this.callTask.scenarioResult.items.length; i++) {
          this.results = this.results.concat(['', ''])
          this.results = this.results.concat(Object.entries(this.callTask.scenarioResult.items[i]))
        }
        // this.results = this.callTask.scenarioResult.items
        // this.results = Object.entries(this.callTask.scenarioResult)
        this.isSaved = true
      }).catch((error) => {
        console.log(error)
        // this.openNotificationWithType('danger', 'Ошибка загрузки информации о тестовом звонке. ')
        this.callTask.campaign = this.$props.id
      })
    },
    loadCampaign () {
      this.$http.get(CAMPAIGNS_API + '/' + this.$props.campaignid, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.campaign = response.data
          // this.callTask.campaign = this.campaign
        })
    },
    cancel () {
      this.$router.push('/callTasksTest/' + this.$props.campaignid)
    },
    getDateTime (time) {
      var d = new Date(time)
      var day = d.getUTCDate()
      var month = d.getUTCMonth() + 1
      var year = d.getUTCFullYear()
      var hour = d.getUTCHours()
      var minute = d.getUTCMinutes()
      if (day < 10) day = '0' + day
      if (month < 10) month = '0' + month
      if (hour < 10) hour = '0' + hour
      if (minute < 10) minute = '0' + minute
      return day + '.' + month + '.' + year + ' ' + hour + ':' + minute + ' UTC'
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';

.time {
  margin: 0px 10px;
}
.info input {
  width: 100%;
}


</style>



// WEBPACK FOOTER //
// TestCallTasksResult.vue?d7b88590